
import React from "react";


const ResetPassword = () =>{
    return(
        <div className="row">
            <div className="col-lg-8 mx-auto">
                <div className="card">
                    <div className="card-header">
                        <h5 className="mb-0">Reset Password</h5>
                    </div>
                    <div className="card-block">
                        <div className="row">
                            <div className="col-lg-4">
                                <label className="form-label">Old Password</label>
                            </div>
                            <div className="col-lg-8">
                                <div className="form-group mb-4">
                                    <input type="password" className="form-control input-me" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <label className="form-label">New Password</label>
                            </div>
                            <div className="col-lg-8">
                                <div className="form-group mb-4">
                                    <input type="password" className="form-control input-me" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <label className="form-label">Confirm Password</label>
                            </div>
                            <div className="col-lg-8">
                                <div className="form-group mb-4">
                                    <input type="password" className="form-control input-me" />
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 text-end">
                            <button className="btn btn-primary">Change Password</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;